import React from 'react';

const NotFound = () => {
  return (
    <section className="content-wrapper is-404">
      <div className="error-graphic">
        <div className="wrapper-narrow">
          <img src={__('members.notFound.imageUrl')} alt="404 icon" />
          <h1>{__('members.notFound.title')}</h1>
        </div>
      </div>
    </section>
  );
};

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/NotFound/index.js
 **/